import { render, staticRenderFns } from "./accepting_orders_table.vue?vue&type=template&id=096617f8&lang=pug&"
import script from "./accepting_orders_table.vue?vue&type=script&lang=js&"
export * from "./accepting_orders_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports